import { z } from 'zod';
export const AUDIENCE_AI_KINDS = ['fact', 'hypothesis'];
export const AUDIENCE_AI_STATUSES = ['pending', 'accepted', 'dismissed'];
export const audienceAiRecommendationUpdateSchema = z.object({
    status: z.enum(['accepted', 'dismissed']),
});
export const audienceAiLlmItemSchema = z.object({
    title: z.string().min(1).max(200),
    body: z.string().min(1).max(4000),
    kind: z.enum(AUDIENCE_AI_KINDS),
    evidence_ids: z.array(z.string().max(80)).max(20),
});
export const audienceAiLlmResponseSchema = z.object({
    recommendations: z.array(audienceAiLlmItemSchema).max(8),
});
//# sourceMappingURL=audienceAiRecommendation.js.map